export const ICON_COLORS = {
    RED: "red",
    YELLOW: "yellow",
    BLUE: "blue",
    VIOLET: 'violet',
    GREY: 'grey'
}